import { OTHER_CKBX_VAL } from "./OtherCheckboxUtils";

export const ACTIVITY_BUTTON_GROUPS = [ 
  {
    legend: 'Full access to a computing device',
    buttons: [
      {
        value: 'social-media',
        label: 'Use social media',
        moreInfo: ''
      },
      {
        value: 'write',
        label: 'Write messages or documents',
        moreInfo: ''
      },
      {
        value: 'zoom',
        label: 'Use Zoom',
        moreInfo: '(or similar video conferencing tool)'
      },
      {
        value: 'email',
        label: 'Use email',
        moreInfo: ''
      },
      {
        value: 'internet',
        label: 'Use online tools',
        moreInfo: '(for shopping, banking, scheduling, etc.)'
      },
      {
        value: 'mainstream-games',
        label: 'Play mainstream computer games',
        moreInfo: ''
      },
      {
        value: 'specialized',
        label: 'Use specialized software',
        moreInfo: '(like AutoCAD, graphics apps, other less common programs)'
      }
    ]
  },
  {
    legend: 'Early access activities',
    buttons: [
    {
      value: 'help',
      label: 'Activate a call light',
      moreInfo: '(or ask for help)'
    },
    {
      value: 'toy',
      label: 'Play with a switch-adapted toy',
      moreInfo: ''
    },
    {
      value: 'on-off',
      label: 'Control a preferred activity',
      moreInfo: '(e.g., play a video)'
    },
    {
      value: 'game',
      label: 'Play a game',
      moreInfo: '(on a computer or other device)'
    },
    {
      value: 'build-communication',
      label: 'Build skills toward communication',
      moreInfo: ''
    },
    {
      value: 'build-access',
      label: 'Build skills toward full access of computer or speech-generating device',
      moreInfo: ''
    }
    ]
  },
  {
    legend: 'Access for low/no-tech communication',
    buttons: [
      {
        value: 'yes-no',
        label: 'Give yes-no responses',
        moreInfo: ''
      },
      {
        value: 'signal',
        label: 'Signal for attention',
        moreInfo: `(get someone's attention)`
      },
      {
        value: 'comm-board',
        label: 'Use a communication board',
        moreInfo: '(not a device)'
      }  
    ]
  },
  {
    legend: '',
    buttons: [
      {
        value: OTHER_CKBX_VAL,
        label: 'Other',
        moreInfo: '(specify)'
      },
    ]
  }

];

// Flatten the button structure into an array of all the buttons
// //(or could do result = ACTIVITY_BUTTONS.map(a => a.buttons) followed by result.flat();)
    // for(let i=0; i<ACTIVITY_BUTTONS.length; i++){
    //   availableBtns.push(...ACTIVITY_BUTTONS[i].buttons);
    // }

export function extractActivityButtons(){
  let availableBtns = [];
  for(let i=0; i<ACTIVITY_BUTTON_GROUPS.length; i++){
    availableBtns.push(...ACTIVITY_BUTTON_GROUPS[i].buttons);
  }
  return availableBtns;
}

//Takes an array of activities, like ['social-media', 'zoom'],
//and returns an array with the same contents, but sorted in the order
//they are presented in the UI.
//This ensures that our reports and other displays show the activities in
//a sensible order, since they are scrambled when stored by the database.
export function sortActivityList(activityList){
  if(Array.isArray(activityList)){
    let availableBtns = extractActivityButtons();
    let orderedActivityList = availableBtns.map(a=>a.value);
    activityList.sort(
      (a,b) => orderedActivityList.indexOf(a) - orderedActivityList.indexOf(b)
    );
  }
  return activityList;
}

export function extractLowTechActivities(){
  let lowTechActivities = []; //array of string values
  let lowTechButtons = ACTIVITY_BUTTON_GROUPS[2].buttons;
  lowTechActivities = lowTechButtons.map(b => b.value);
  return lowTechActivities;
}

//NOTE: returns False if activity is falsy. 
//there has to be something in activity to return True.
export function isActivityLowTech(activity){
  const lowTechActivities = extractLowTechActivities();

  return lowTechActivities.includes(activity);
}

//NOTE: returns False if chosenActivities is falsy. 
//there has to be something in chosenActivities to return True.
export function areAllLowTech(chosenActivities){
  let lowTechOnly = true;
  const lowTechActivities = extractLowTechActivities();

  chosenActivities.forEach((activity) => {
    lowTechOnly = lowTechOnly && lowTechActivities.includes(activity);
  });
  return lowTechOnly && (chosenActivities.length > 0);
}

export function getActivityLabelForValue(value){
  let matchingLabel = "";
  let availableBtns = extractActivityButtons();
  availableBtns.forEach(btn => {
    if(btn.value === value)
      matchingLabel = btn.label;
  })
  return matchingLabel;
}

